<template name = "dateTemplate" lang="html">
	<div class="row">
	<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
	<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
		<div class="sidebar-header">
			<h5>Search</h5>
			<a href="" id="sidebarMenuClose"><feather type="x" class="svg_overflow"></feather></a>
		</div><!-- df-sidebar-header -->
		<div class="sidebar-body">
			<!-- inputSearchForms -->
			<div v-if="properties.uid">
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div v-if="form.attr != 'clientid'" class="form-group">
						<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
						<input type="email" class="form-control" :name="form.id" v-model.lazy="receptionData[form.id]" :id="form.id" :placeholder="form.name">
					</div>
												<div v-else class="form-group">
														<label :for="form.id">{{form.name}}</label>
														<b-field>
																<b-autocomplete
																		v-model="clientId"
																		:id="form.id"
																		ref="clientId"
																		:data="filteredClientDataArray"
																		:placeholder="form.name"
																		@select="option => selected = option">
																</b-autocomplete>
														</b-field>
												</div>
				</ul>
			</div>
			<div v-else>
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C' && form.name != 'Department'  && form.name != '입고날짜'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
						<input type="email" class="form-control" :name="form.id" v-model.lazy="receptionData[form.id]" :id="form.id" :placeholder="form.name">
					</div>
				</ul>
				<ul class="sidebar-nav" v-for="(form, i) in inputSearchForms " v-if="form.division === 'C' && form.name != 'Department'   && form.name === '입고날짜'">
					<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
					<div class="form-group">
						<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C'">*</span></label>
						<li class="nav-item"><date-picker @dp-change="dateKeyupEvent" v-model="receptionData[form.id]" :config="datePickerOptions"  autocomplete='off' placeholder="입고날짜" :id="form.id" aria-label="Search" ignoreReadonly/></li>
					</div>
				</ul>
			</div>
			<ul class="sidebar-nav" v-else-if="form.division === 'O'">
				<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
				<div class="form-group">
					<label for="formGroupExampleInput" class="d-block has-text-weight-semibold">{{form.name}}</label>
					<p class="mg-b-0 text-left" v-if="form.value.length > 0"><span v-for="(form1, i) in form.value" v-if="form1.codeCode == receptionData[form.id]">{{form1.codeName}}</span></p>
					<p class="mg-b-0 text-left" v-else-if="form.name == 'Reception No'">
						<a href='#modal14' @click='sendId(properties.uid)' data-toggle="modal" data-animation="effect-flip-horizontal">{{receptionData[form.id]}}</a>
					</p>
					<p class="mg-b-0 text-left" v-else>
						{{receptionData[form.id]}}
					</p>
				</div>
			</ul>
			<!-- inputCompanyForms -->
			<ul class="sidebar-nav" v-for="(form, i) in inputCompanyForms ">
				<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
				<div class="form-group">
					<label :for="form.id">{{form.name}}<span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
					<b-field>
						<b-autocomplete
							v-model="companyName"
							:id="form.id"
							ref="companyName"
							:data="filteredCompanyDataArray"
							:placeholder="form.name"
							@select="option => selected = option">
							<template slot="empty">No results found</template>
						</b-autocomplete>
					</b-field>
				</div>
			</ul>
								<!-- inputCompanyForms -->
			<ul class="sidebar-nav" v-for="(form, i) in inputClientForms ">
				<li class="nav-label mg-b-10-f" v-if="i === 0">&nbsp;</li>
				<div class="form-group">
												<label :for="form.id">{{form.name}}</label>
					<b-field>
						<b-autocomplete
							v-model="clientId"
							:id="form.id"
							ref="clientId"
							:data="filteredClientDataArray"
							:placeholder="form.name"
							@select="option => selected = option">
						</b-autocomplete>
					</b-field>
				</div>
			</ul>
			<!-- checkboxSearchForms -->
			<ul class="sidebar-nav" v-for="(form, i) in checkboxSearchForms">
				<div class="form-group">
					<label for="formGroupExampleInput" class=" d-block has-text-weight-semibold">{{form.name}}</label> 
					<div class="ml-2 custom-control custom-radio mb-1" v-for="(form1, i) in form.value">
						<input type="radio" :id="form1.codeCode" :name="form.id" :value="form1.codeCode" v-model="receptionData[form.id]" class="custom-control-input" :checked="form1.codeCode == receptionData[form.id]">
						<label class="custom-control-label" :for="form1.codeCode">{{form1.codeName}}</label>
					</div>
				</div>
			</ul>
			<!-- dateSearchForms -->
			<ul class="sidebar-nav" v-for="(form, i) in dateSearchForms">
				<div class="form-group">
					<label :for="form.id">{{form.name}} <span class="tx-danger has-text-weight-semibold" v-if="form.division === 'C' && form.attr">*</span></label>
					<p v-if="form.name == '생성일'" class="mg-b-0 text-left">{{receptionData[form.id]}}</p>
												<date-picker v-if="form.name == '입고일'" v-model="form.value" :config="datePickerOptions" class="form-control" autocomplete='off' :placeholder="form.name" :id="form.id" v-model.lazy="receptionData[form.id]" aria-label="Search" ignoreReadonly/>
												<date-picker v-else-if="form.name == '완료예정일(TAT)'" v-model="form.value" :config="datePickerOptions" class="form-control" autocomplete='off' :placeholder="form.name" :id="form.id" v-model.lazy="receptionData[form.id]" aria-label="Search" ignoreReadonly/>
				</div>
			</ul>
			<ul class="sidebar-nav">
					 <li class="d-block mb-1 has-text-weight-semibold">Sample Box Image upload</li>
			</ul>
			<div>
				<imgUpload @imgFileHandler="this.imgFileHandler"/>
			</div>

			<div class="card card-body p-1 paste-background-color">
					<input type="text" @paste="onPaste" multiple="multiple" class="img-input paste-background-color" placeholder="Paste your images here"></input>
					<img id="pasteImg"/>
					<p id='countPasteImg' class='m-0'></p>
					<!-- <button type="button" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5"><i data-feather="image" class="wd-10 mg-r-5"></i>Upload</button> -->
			</div>

			<ul class="sidebar-nav" style="margin-top:10px">
				<li class="d-block mb-1 has-text-weight-semibold">Sample List upload</li>
			</ul>
		
			<div>
				<!-- <form id='fileUpTest' method="POST" enctype="multipart/form-data"> -->
				<excelUpload @excelFileHandler="this.excelFileHandler"/>
				<!-- </form> -->
			</div>

		</div><!-- sidebar-body -->
	</div><!-- sidebar -->
	<div class="content content-components pd-b-0-f overflow-hidden">
		<div class="pd-x-0 pd-lg-x-10 pd-xl-x-0">
			<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
				<div>
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb breadcrumb-style1 mg-b-10">
							<li class="breadcrumb-item">{{this.mainName}}</li>
							<li class="breadcrumb-item" aria-current="page">{{this.subName}}</li>
							<li class="breadcrumb-item active" aria-current="page">Detail</li>
						</ol>
						<h4 class="mg-b-0 tx-spacing--1">{{this.subName}} Detail</h4>
					</nav>
				</div>

				<div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end">
					<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="confirmData()"><feather type="folder" class="wd-10 mg-r-5 svg_overflow"></feather>Confirm</button>
					<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData(true)"><feather type="folder" class="wd-10 mg-r-5 svg_overflow"></feather>Save</button>
					<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-if="properties.uid" v-on:click="deleteData()"><feather type="delete" class="wd-10 mg-r-5 svg_overflow"></feather>delete</button>
					<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goPage()"><feather type="file" class="wd-10 mg-r-5 svg_overflow"></feather>List</button>
				</div>
			</div>
				<!-- <feather v-if="imgData.length > 0" type="image" data-toggle="collapse" data-target="#ViewGel" class="svg_overflow svg-cursor"></feather> -->
				<div class="gel-container">
					<div class="row">
						<div class="cart">
							<div v-draggable class="items-list collapse" style="max-width:1500px;" v-bind:style="{width: ((imgData.length*180)+(imgData.length*20))+'px'}" id="ViewGel">
								<div style="white-space:nowrap; overflow-x:scroll;" class="viewer-scroll">
									<imageViewer :image="imgData"  @deleteImgFile="this.deleteImgFile"/>
								<div class="chart-three clearfix">
									<div id="flotChart5" class="flot-chart ht-30"></div>
								</div>
								</div>
								<div class="row">
									<div class="view-cart">
										<span class="close-cart" data-toggle="collapse" data-target="#ViewGel">Close</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			<div class="card col-lg-8 col-xl-7 mg-b-20 mg-lg-b-25">
				<div class="d-none d-md-block tx-right-f mg-xs-y-15-f">
					<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 is-pulled-left" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.checkAll"><feather type="check" class="wd-10 mg-r-5 svg_overflow"></feather>Checked</a>
					<!-- <a href="#ViewGel" v-if="imgData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-secondary btn-uppercase mg-l-5" data-toggle="collapse" data-animation="effect-flip-horizontal"><feather type="image" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLE BOX</a> -->
					<button v-if="this.downloadList.Excel.length > 0" @click="excelDialogHandler()" class="btn btn-xs pd-x-15 btn-info btn-uppercase mg-l-5-f"><feather type="file-text" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Sample_List</button>
												<a href="" v-if="imgData.length > 0" class="btn btn-xs pd-x-15 btn-info btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" @click="dialogHandler('img')" ><feather type="image" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>SAMPLE BOX</a>
					<a href="#modal11" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal"><feather type="plus" class="wd-10 mg-r-5 svg_overflow"></feather>Add</a>
					<a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5" data-toggle="modal" data-animation="effect-flip-horizontal" v-on:click="this.sampleDelColumn"><feather type="minus" class="wd-10 mg-r-5 svg_overflow"></feather>Delete</a>
				</div>
				<hot-table id='sample-table' :settings="sheetSettings" :data="sampleData" class="ht-hot-table" ref="sheet" :afterChange="changeData"></hot-table>
			</div><!-- card -->
								<v-app>
										<v-row justify="space-around">
												<v-col cols="auto">
												<v-dialog v-model="imgDialog" transition="dialog-bottom-transition" max-width="600" style='z-index:20001;'>
														<!-- <v-system-bar lights-out></v-system-bar> -->
															<v-carousel>
																<v-carousel-item
																v-for="(item,i) in imgData"
																:key="item.id"
																:src="'data:'+item.type.trim()+';base64,'+ item.img"
																reverse-transition="fade-transition"
																transition="fade-transition">
																<v-btn depressed color="primary" block @click="dialogHandler('delete')">
																		Delete Image
																</v-btn>
																<v-dialog v-model="deleteDialog" transition="dialog-bottom-transition" max-width="300" style='z-index:20001;'>
																		<div class="text-center">
																				<v-sheet class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block" >
																						<div class="text-body-2 mb-4"> Are you sure you want to delete this image? </div>
																						<v-btn class="ma-1" color="grey" plain @click="deleteDialog = false">Cancel</v-btn>
																						<v-btn :loading="deleteLoading" class="ma-1" color="error" plain @click="deleteImgFile(item)"> Delete </v-btn>
																				</v-sheet>
																		</div>
																</v-dialog>
																</v-carousel-item>
														</v-carousel>
												</v-dialog>
												</v-col>
										</v-row>
								</v-app>
		</div>
	</div>
	<div class="modal fade" id="modal11" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel11" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered" role="document">
			<div class="modal-content tx-14">
				<div class="modal-header">
					<h6 class="modal-title" id="exampleModalLabel11">Sample Create</h6>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<div class="modal-body">
					<p class="mg-b-0">Please enter the number of samples to register.</p>
					<p class="mg-b-0">&nbsp;</p>
					<p class="mg-b-0"><input type="number" min='1' max='100' id='addNum' class="form-control"></p>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-secondary tx-13" data-dismiss="modal">Close</button>
					<button type="button" class="btn btn-primary tx-13" data-dismiss="modal" v-on:click="this.sampleAddColumn">Add</button>
				</div>
			</div>
		</div>
	</div>

		<div class="modal fade" id="modal14" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel14" aria-hidden="true">
		<div class="modal-dialog modal-dialog-centered chat-width" role="document">
			<div class="modal-content tx-14 chat-height">
				<div class="modal-header">
				<h6 class="modal-title" id="exampleModalLabel14">Chat</h6>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
				</div>
				<div class="modal-body">
					<Chat></Chat>
				</div>
			</div>
		</div>
	</div><!-- chat modal -->

	<v-app id="inspire">
				<div>
						<v-row
								justify="center"
						>
								<v-dialog
								v-model="excelDialog"
								max-width="500px"
								style='z-index:20001;'
								>
										<v-card>
												<v-card-title>
												Download Report
												</v-card-title>
												<v-card-text>
												<v-select
														v-model="selectExcel"
														:items="downloadList['Excel']"
														label="Select a Excel"
														item-value="text"
												></v-select>
												</v-card-text>
												<v-card-actions>
												<v-btn
														color="secondary"
														text
														@click="excelDialog = false"
												>
														Close
												</v-btn>
												<v-btn
														color="primary"
														text
														@click="loadExcel()"
												>
														Load
												</v-btn>
												<v-btn
														color="accent"
														text
														@click="deleteExcel_DialogHandler()"
												>
														Delete
												</v-btn>
												</v-card-actions>
										</v-card>
								</v-dialog>
						</v-row>
				</div> 	
		</v-app>
 <v-app id="inspire">
	<v-row justify="center">
		<v-dialog
			v-model="deleteExcelDialog"
			persistent
			max-width="290"
		>
			<v-card>
			<v-card-title class="text-h6">
				Are you sure you want to delete?
			</v-card-title>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
				color="secondary"
				text
				@click="deleteExcelDialog = false"
				>
				Cancel
				</v-btn>
				<v-btn
				color="primary"
				text
				@click="deleteExcel()"
				>
				OK
				</v-btn>
			</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</v-app>
</div>
</template>
<script>
import datePicker from "vue-bootstrap-datetimepicker";
import Handsontable from "handsontable";
import { HotTable } from "@handsontable/vue";
import "handsontable-key-value";
import common from "@/views/Common/common.js";
import mediage from "@/views/Common/mediage/column.js";
import Chat from "@/views/Common/Chat";
import { Buefy } from 'buefy';
import imgUpload from '@/views/Common/image-upload/imgUpload';
import imageViewer from "@/views/Common/image-upload/Viewer";
import excelUpload from '@/views/Common/excel-upload/excelUpload'

// 이미지 드래거블
import { Draggable } from 'draggable-vue-directive'


// Header의 메뉴 정보 호출을 위한 bus event
import { bus } from "../../main";

export default {
name: "Detail",
props: ["properties"],
directives: {Draggable,},
data() {
	return {
		mainName: "",
		subName: "",
		menuData: [], // header.vue data

		mid: "", // menu list id
		msid: "", // menu sheet id
		uid: "", // sheet id
		ssid: "", // sample list id

		/* Reception input Form */
		receptionHeader: [], // 입력 값 header column
		inputSearchForms: [], // 입력 input form
		dateSearchForms: [], // 입력 date form
		checkboxSearchForms: [], // 입력 radio form
		inputCompanyForms: [], // 입력 company form
						inputClientForms: [], // 입력 company form
		inputUserForms: [], // 입력 user form
		inputFigureForms: [], // 입력 figure form

		/* Reception input Form Value */
		receptionData: [],
		defaultReceptionData: {},

		// 데이터 변경 여부
		isWork: 0,

		/* Sample Form */
		sampleHeader: [], // Sample Header
		sampleData: [], // Sample list data
		defaultSampleData: [], // Pre Sample linst data
		sampleChangeData: [], // Sample list change data
		changeCount: 0,
		boolChange: false, // data change ckeck

		/* company auto text */
		companyName: "",
		companyData: [],
		autoCompanyData: [],
		/* Loading */
		isLoading: false,
		isFullPage: true,

		/* client auto text */
		clientId: "",
		clientData: [],
		autoClientData: [],

		width: 0,
		height: 0,
		// date setting
		datePickerOptions: {
			format: "YYYY-MM-DD",
			useCurrent: false,
			showTodayButton: true,
			keepInvalid: false,
			ignoreReadonly: true,
		},
		// image upload
		imgFileFormData: new FormData,
		imgFileHandleFlag: false,
		pasteForm: new FormData,
		pasteFlag: false,
		pasteCount:0,
		imgId: [],
		imgData: [],
						imgDialog : false,
						deleteDialog : false,
						deleteLoading : false,
						selectImg : {},

		// excel upload
		excelFileFormData: new FormData,
		excelFileHandleFlag: false, 
		excelId: [],
		excelDialog: false,
		deleteExcelDialog: false,
		selectExcel: '',
		downloadList: {
			"Excel": [],
		},

						headerChange : false,
	};
		},
	
created() {
	bus.$on("menu_data", data => {
		this.menuData = data;
		this.classifyHeader();
		this.getAutoCompleteData();
		this.getImgFile();
		this.getExcel();
	});
	window.addEventListener('resize', this.handleResize);
	this.handleResize();
},
destroyed(){
	window.removeEventListener('resize', this.handleResize);
},
mounted() {
	this.$nextTick(function (){
		$("#gelimage").draggable();
	});
	window.addEventListener("scroll", this.onScroll);
},
methods: {
	dateKeyupEvent(e) {
		if (e.oldDate != null) this.classifyData();
	},
	beforeDestroy() {
		bus.$off("menu_data");
		window.removeEventListener("scroll", this.onScroll);
	},
	handleResize() {
		this.width = window.innerWidth;
		this.height = window.innerHeight;
	},
				dialogHandler(input) {
						if(input == 'img'){
								this.imgDialog = true;
						}else if(input == 'delete'){
								this.deleteDialog = true;
						}
				},
	/*
	* Load Data Reception Headers
	*/
	async classifyHeader() {
	this.openLoading();
	let data = common.menuHeader(this.properties.mid, this.menuData, 0);
	this.mainName = data[0];
	this.subName = data[1];
	this.msid = data[2];
	this.receptionHeader = data[3];
	this.inputSearchForms = [];
	this.inputCompanyForms = [];
	this.inputClientForms = [];
	this.dateSearchForms = [];
	this.checkboxSearchForms = [];
	console.log('this.receptionHeader', this.receptionHeader)
	for (let i in this.receptionHeader) {
		if (this.receptionHeader[i].columnType == "LIST") {
			console.log('this.receptionHeader[i].columnAttr', this.receptionHeader[i].columnAttr)
		if (this.receptionHeader[i].columnAttr == "statecode") {
			if (!common.isNull(this.properties.uid)) {
			this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: this.receptionHeader[i].code,id: this.receptionHeader[i].columnCode,division: "O", 'attr':this.receptionHeader[i].columnAttr});
			}
			console.log('push', {name: this.receptionHeader[i].columnName,value: this.receptionHeader[i].code,id: this.receptionHeader[i].columnCode,division: "O", 'attr':this.receptionHeader[i].columnAttr})
		} else {
			this.checkboxSearchForms.push({name: this.receptionHeader[i].columnName,id: this.receptionHeader[i].columnCode,value: this.receptionHeader[i].code,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
		}
		} else if (this.receptionHeader[i].columnType == "DATE") {
			this.dateSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
		} else if (this.receptionHeader[i].columnType == "COUNT") {
		} else if (this.receptionHeader[i].columnType == "PIPELINE") {
		} else if (this.receptionHeader[i].columnType == "FIGURE") {
		} else if (this.receptionHeader[i].columnType == "COMPANY") {
			if (!common.isNull(this.properties.uid))this.inputCompanyForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
			else this.inputCompanyForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
		} else {
			if (this.receptionHeader[i].columnName != "No") {
				if (!common.isNull(this.properties.uid)) {
						this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
				} else {
					if (this.receptionHeader[i].columnDivision == "C"){
														if(this.receptionHeader[i].columnAttr == 'clientid'){
																if (!common.isNull(this.properties.uid))this.inputClientForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
											else this.inputClientForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
														}else{
																this.inputSearchForms.push({name: this.receptionHeader[i].columnName,value: "",id: this.receptionHeader[i].columnCode,division: this.receptionHeader[i].columnDivision, 'attr':this.receptionHeader[i].columnAttr});
														}
												}
				}
			}
		}
	}
	this.classifySampleHeader();
	},
	/*
	* Load Data Sample Headers
	*/
	async classifySampleHeader() {
	let data = common.detailSamples(this.menuData);
	this.ssid = data[0];
	this.sampleHeader = data[1];
	this.sheetSettings.hiddenColumns.columns = [2]; //2번째 컬럼 숨기기
	this.$refs.sheet.settings.columns = []; //this.$refs 사용시 초기화를 해줘야함
	this.$refs.sheet.settings.colHeaders = [];
	for (let i in this.sampleHeader) {
		if (i < 1) {
			this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("");
			this.$refs.sheet.settings.columns.push({sampleData: "checkbox",type: "checkbox",width: "20px"});
		}
		this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat(this.sampleHeader[i].columnName);
		if (Number(this.sampleHeader[i].columnSort) < 4) {
			
			if (this.sampleHeader[i].columnName == "No") {
				this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text",readOnly: true,width: "30px"});
				this.$refs.sheet.settings.colHeaders = this.$refs.sheet.settings.colHeaders.concat("id");
				this.$refs.sheet.settings.columns.push({sampleData: "id",type: "text",width: "20px",readOnly: true});
			} else {
				this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text",readOnly: true});
			}
		} else {
			if (this.sampleHeader[i].columnType === "LIST") {
				var source = [];
				for (let j in this.sampleHeader[i].code) {
					if (j == 0) {
						source.push({id:null, name:''});
					}
					source.push({id: this.sampleHeader[i].code[j].codeCode,name: this.sampleHeader[i].code[j].codeName});
				}
				if (this.sampleHeader[i].columnAttr === "statuscode") {
					this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "key-value",readOnly: true,filter: false,source: source,keyProperty: "id",valueProperty: "name"});
				} else {
					this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "key-value",filter: false,source: source,keyProperty: "id",valueProperty: "name"});
				}
			} else if (this.sampleHeader[i].columnType === "DATE") {
				this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "date",dateFormat: "YYYY-MM-DD"});

			} else this.$refs.sheet.settings.columns.push({sampleData: this.sampleHeader[i].columnCode,type: "text"});
		}
	}
	this.classifyData();
	},
	/*
	* Load Data Headers & Samples Data
	*/
	async classifyData() {
	if (!common.isNull(this.properties.uid)) {
		var params = [];
		params = { ssid: this.ssid };
		params["uid"] = this.properties.uid;
		var request = { params: params };
		await this.$axios.get(this.$apiHost + "/receptions/detail", request).then(res => {
			this.receptionData = res.data;
			console.log('this.receptionData', this.receptionData)
			for (let i in res.data) this.defaultReceptionData[i] = res.data[i]; // 불필요한 저장을 방지 하기 위하여 처음 불러온 데이터를 배열에 넣어준다 (key:value)
		})
		.catch(err => {
			console.log(err);
		});
		var thisData = [];
		var preData = [];
		for (let i in this.receptionData.samples) {
			this.receptionData.samples[i].No = Number(i) + 1;
			thisData = thisData.concat("false");
			for (let j in this.sampleHeader) {
				if (this.sampleHeader[j].columnName == "No") {
					thisData = thisData.concat(this.receptionData.samples[i].No);
					thisData = thisData.concat(this.receptionData.samples[i].id);
					preData = preData.concat(this.receptionData.samples[i].No);
					preData = preData.concat(this.receptionData.samples[i].id);
				} else {
					thisData = thisData.concat(this.receptionData.samples[i][this.sampleHeader[j].columnCode]);
					preData = preData.concat(this.receptionData.samples[i][this.sampleHeader[j].columnCode]);
				}
			}
			this.sampleData.push(thisData);
			this.defaultSampleData.push(preData);
			thisData = [];
			preData = [];
						} 
						//2020-11-05 수정 hjh
		if (!common.isNull(this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")])) this.companyName = this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")];
						if (!common.isNull(this.receptionData[common.find_last_column(this.receptionHeader, "clientid")])) this.clientId = this.receptionData[common.find_last_column(this.receptionHeader, "clientid")];
	}
	this.rendertab();
	this.isLoading = false;
	},
	/*
	* Sample Add Column
	*/
	async sampleAddColumn() {
		let sampleData = [];
		const colCnt = this.$refs.sheet.hotInstance.countRows();
		const colNum = $("#addNum").val();
		$("#addNum").val("");
		for (let i = Number(colCnt); i < Number(colCnt) + Number(colNum); i++) {
			if (i === 0) {
				this.openLoading();
			}
			this.sampleData.push({ 1: Number(i) + 1 });
			if (i === Number(colCnt) + Number(colNum) - 1) {
				this.isLoading = false;
			}
		}

		// 데이터 변경 여부
		this.isWork++;
		this.rendertab();
		this.isLoading = false;
	},
	/*
	* Sample Delete Column
	*/
	async sampleDelColumn() {
	const colCnt = this.$refs.sheet.hotInstance.countRows();
	for (let i = colCnt - 1; i >= 0; i--) {
		if (this.$refs.sheet.hotInstance.getDataAtCell(i, 0) == true) {
		this.$refs.sheet.hotInstance.alter("remove_row", i, 1);
		}
	}
	for (let i = 0; i < this.$refs.sheet.hotInstance.countRows(); i++) {
		this.$refs.sheet.hotInstance.setDataAtCell(i, 1, i + 1);
	}
	// 데이터 변경 여부
	this.isWork++;
	this.rendertab();
	this.isLoading = false;
	},
	/*
	* Sample Data Change Arrary Insert
	*/
	async changeData(source) {
	if (this.$refs.sheet.hotInstance) {
		this.sampleChangeData = this.$refs.sheet.hotInstance.getData();
	}
	if (arguments[1] === "edit" || arguments[1] === "Autofill.fill") {
		//문제 없음
		// arguments[0][0][3] => 입력값 arguments[0][0][0] => rownum
		// arguments[0][0][2] (이전 데이터) arguments[0][0][3] (변경 데이터)
		if (!common.isNull(arguments[0][0][3])) {
			if (arguments[0][0][3] != arguments[0][0][2]) {
				// 변경된 값이 같은 경우를 대비
				this.boolChange = true;
			}
		}

		if (arguments[0][0][2] && !arguments[0][0][3]) {
			this.boolChange = true;
		}
	} else if (this.isWork > 0) {
		this.boolChange = true;
	}
	},
	/*
	* Reception & Samples Create data
	*/
	async createData(evt) {
		if (evt) {
			this.openLoading();
		}
		var params = [];
		var sendKey = "";
		var sendValue = "";
		var changeData = [];
		var thisData = [];
		for (let i in this.sampleChangeData) {
			for (let j in this.sampleChangeData[i]) {
				if (j > 2) {
					changeData[this.sampleHeader[Number(j - 2)].columnCode] = this.sampleChangeData[i][j];
				}
			}
			thisData.push($.extend(true, {}, changeData));
			changeData = [];
		}

		params = {
			msid: this.msid,
			uid: this.properties.uid,
			ssid: this.ssid,
			mediAgeFlag: false,
			samples: thisData
		};
	if (!common.isNull(this.companyName))this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")] = this.companyName;
				if (!common.isNull(this.clientId))this.receptionData[common.find_last_column(this.receptionHeader, "clientid")] = this.clientId;
	for (let i in this.receptionHeader) {
		sendKey = this.receptionHeader[i].columnCode;
		sendValue = this.receptionData[this.receptionHeader[i].columnCode];
		if (
		this.receptionData[this.receptionHeader[i].columnCode] !=
		this.defaultReceptionData[this.receptionHeader[i].columnCode]
		) {
			this.boolChange = true;
		}
		
		if (sendValue) {
			params[sendKey] = sendValue;
		}
				}
				let requiredHeader = common.findRequiredByHeader(this.receptionHeader) //리스트 필수값
				for (let i in requiredHeader) { 
						if(!requiredHeader[i].columnAttr == 'clientId'){
								let check = Object.keys(params).find(item => item == requiredHeader[i].columnCode);
								if (!check) {
										this.$buefy.dialog.alert({
												message: 'Please Enter '+requiredHeader[i].columnName,
												size: 'is-medium',
												type: 'is-danger'
										})
										this.isLoading = false;
										return false;
								}
						}
				}
				if(this.boolChange){
					this.$axios.post(this.$apiHost+'/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
					.then(res=>{
			if (res.data.message !== '') {
				this.$buefy.notification.open({
					duration: 2000,
					message: res.data.message,
					position: 'is-bottom-right',
					type: 'is-success',
					hasIcon: true
				})
			} else {
				this.$buefy.notification.open({
					duration: 2000,
					message: res.data.message,
					position: 'is-bottom-right',
					type: 'is-danger',
					hasIcon: true
				})
			}
								sessionStorage.setItem('uid',res.data.uid);
								this.properties.uid = res.data.uid;
								this.boolChange = false;
								this.isLoading = false;

			this.upload();
			this.excelUpload();
			let delayTime = 1000;
			const timeoutObj = setTimeout(async () => {
				if (evt) {
											this.$router.go({name:this.$route.name});
				} else {
					this.confirmData();
				}
			}, delayTime);
							
					})
					.catch(err=>{
						if(err){
										this.$buefy.dialog.alert({
												message: 'The system failed and the save failed. Please contact your system administrator.',
												size: 'is-medium',
												type: 'is-danger'
										})
						}
						console.log(err)});

				}else{
					this.isLoading = false;
						this.$buefy.dialog.alert({
								message: 'No data has been changed. Can not save.',
								size: 'is-medium',
								type: 'is-danger'
						})
					return false;
				}
		},

		/*
		* confirm Data page Move
		*/
		async confirmData() {
			alert('zzz')
				if (this.properties.uid) {
						let orderDateColumn = this.receptionHeader.find(column => column.columnAttr == 'orderdate');
						let dueDateColumn = this.receptionHeader.find(column => column.columnAttr == 'duedate');
						// this.receptionData[common.find_type_code(this.receptionHeader, "COMPANY")] = this.companyName;
						// if(JSON.stringify(this.defaultReceptionData) !== JSON.stringify(this.receptionData)){
						if((this.defaultReceptionData[orderDateColumn.columnCode] != this.receptionData[orderDateColumn.columnCode])||
						this.defaultReceptionData[dueDateColumn.columnCode] != this.receptionData[dueDateColumn.columnCode]){
								if(this.headerChange == true){
										this.headerChange = false;
								}else{
										this.headerChange = true;
								}
						}else{
								this.headerChange = false;
						}
						if (this.boolChange == true || this.headerChange == true) {
								this.createData(false);
								return false;
						}else{
								const uid = this.properties.uid;
								const menuSheetId = this.msid;
								if(this.receptionData.hasOwnProperty(orderDateColumn.columnCode) == false|| this.receptionData.hasOwnProperty(dueDateColumn.columnCode) == false){
										this.$buefy.dialog.alert({
												message: `Please Check '${orderDateColumn.columnName}' or '${dueDateColumn.columnName}'.`,
												size: 'is-medium',
												type: 'is-danger'
										})
										this.isLoading = false;
										return false;
								}else{
										if(this.receptionData[orderDateColumn.columnCode] == null || this.receptionData[dueDateColumn.columnCode] == null){
												this.$buefy.dialog.alert({
														message: `Please Check '${orderDateColumn.columnName}' or '${dueDateColumn.columnName}'.`,
														size: 'is-medium',
														type: 'is-danger'
												})
												this.isLoading = false;
												return false;
										}else{
												this.$buefy.dialog.confirm({
														message: 'Are you sure you want to confirm?',
														size: 'is-medium',
														onConfirm: async () => {
																this.openLoading();
																this.$axios.patch(this.$apiHost + "/" + this.$route.name.replace("_detail", "") + "/confirm",
																{uid, menuSheetId}).then(res => {
																		if (res.data.flag) {
																				this.$buefy.notification.open({
																						duration: 2000,
																						message: res.data.message,
																						position: 'is-bottom-right',
																						type: 'is-success',
																						hasIcon: true
																				})
																		} else {
																				this.$buefy.notification.open({
																						duration: 2000,
																						message: res.data.message,
																						position: 'is-bottom-right',
																						type: 'is-danger',
																						hasIcon: true
																				})
																		}
																		sessionStorage.setItem("uid", uid);
																		this.isLoading = false;
																		this.$router.push({
																				name: "receptions_completion",
																				params: { mid: this.properties.mid, uid: uid, type: "detail" }
																		});
																});
														},
														onCancel: () => {
																this.isLoading = false;
																return false;
														}
												});
										}
								}
						}
				} else {
						this.createData(false);
						return false;
				}
		},
		/*
		* delete Data page Move
		*/
		async deleteData() {
				this.$buefy.dialog.confirm({
						message: 'Are you sure you want to delete?',
						size: 'is-medium',
						onConfirm: async () => {
								var receptionNo = "";
								this.openLoading();
								for (let i in this.receptionHeader) {
										if (this.receptionHeader[i].columnAttr === "receptionno") {
												receptionNo = this.receptionData[this.receptionHeader[i].columnCode];
												break;
										}
								}
								this.$axios.patch(this.$apiHost + "/" + this.$route.name.substring(0, this.$route.name.indexOf("_")) +
										"/delete",
										{ param: { receptionNo: receptionNo } }
								)
								.then(res => {
										this.isLoading = false;
										this.$router.push({
												name: this.$route.name.replace("_detail", ""),
												params: { mid: this.properties.mid, type: "list" }
										});
								})
								.catch(err => {
										if (err) {
												this.$buefy.dialog.alert({
														message: 'The system failed and the deleted failed. Please contact your system administrator.',
														size: 'is-medium',
														type: 'is-danger'
												})
										}
										console.log(err);
								});
						},
						onCancel: () => {
								this.isLoading = false;
								return false;
						}
				});
		},
		/*
		* List page Move
		*/
		goPage() {
				if (this.boolChange) {
						this.$buefy.dialog.confirm({
								message: 'You have changed data. Would you like to leave??',
								size: 'is-medium',
								onConfirm: async () => {
										this.$router.push({
										name: this.$route.name.replace("_detail", ""),
										params: { mid: this.properties.mid, type: "list" }
								});
								},
								onCancel: () => {
										return false;
								}
						});
				
				} else {
						this.$router.push({
								name: this.$route.name.replace("_detail", ""),
								params: { mid: this.properties.mid, type: "list" }
						});
				}
		},

		/*
		* Reception Data Check All
		*/
		async checkAll() {
		const colCnt = this.$refs.sheet.hotInstance.countRows();
		var diffCnt = 0;
		for (let i = 0; i < colCnt; i++) {
				if (this.$refs.sheet.hotInstance.getDataAtCell(i, 0) === true) {
				diffCnt = diffCnt + 1;
				}
		}
		for (let i = 0; i < colCnt; i++) {
				if (diffCnt > 0 && diffCnt <= colCnt) {
				this.$refs.sheet.hotInstance.setDataAtCell(i, 0, false);
				} else {
				this.$refs.sheet.hotInstance.setDataAtCell(i, 0, true);
				}
		}
		this.rendertab();
		},

imgFileHandler(files) {
	if (files.length > 0) {
		let tForm = new FormData();
		for (let i in files) {
			tForm.append('file', files[i])
		}
		let formData = new FormData();
		for (let pair of tForm.entries()) {
			formData.append(pair[0], pair[1]);
		}
		this.imgFileFormData = formData;
		this.imgFileHandleFlag = true;
		this.boolChange = true;
	} else {
		this.imgFileHandleFlag = false;
	}
},

async onPaste(evt) {
	this.pasteFlag = true;
	let file = evt.clipboardData.files[0];
	if (file) {
		this.boolChange = true;
		this.pasteForm.append('file', file);
		let reader = new FileReader();
		var imgtag = document.getElementById("pasteImg");
		reader.onloadend = function () {
			imgtag.src = reader.result;
		}
		this.pasteCount++;

		reader.readAsDataURL(file);
		document.getElementById('countPasteImg').innerHTML = this.pasteCount + ' file(s) selected';
	} else {
		this.$buefy.dialog.alert({
			message: 'Please paste only the file',
			size: 'is-medium',
			type: 'is-danger'
		})
	}
},
async upload() {
	if (this.imgFileHandleFlag || this.pasteFlag || this.imgId.length > 0) {
		try {
			let formData = new FormData();
			if (this.imgFileHandleFlag) {
				formData = this.imgFileFormData;
			} 
			if (this.pasteFlag) {
				for (let pair of this.pasteForm.entries()) {
					formData.append(pair[0], pair[1]);
				}
			}
			formData.append('uid', this.properties.uid);
			formData.append('copyId', this.imgId);
			formData.append('gubun', 'reception');
			console.log(formData)
			await this.$axios.post(`${this.$apiHost}/${this.$route.name.replace("_detail", "")}/upload`, formData, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				}
			}).then(console.log('then')).catch(err=>{console.log(err)})
			return false;
		} catch (error) {
			console.log(error)						
			return false;
		}
	}
},
async getImgFile() {
	//img 가져오기
	console.log(1)

	if(!common.isNull(this.properties.uid)){
		console.log(2)
		var params = []; 
		params = {'uid' : this.properties.uid};
		var request = {params : params}
		await this.$axios.get(`${this.$apiHost}/${this.$route.name.replace("_detail", "")}/image`, request)
		.then(res=>{
			for (let i in res.data) {
				this.imgData.push(res.data[i]);
			}
			if (!common.isNull(this.imgData)) {
				for (let i in this.imgData) {
					this.imgId.push(this.imgData[i].id);
					let image = this.imgData[i].img;
				}
			}
		}).catch(err=>{console.log(err)});
	} 
},
async deleteImgFile(param) {
	try {
		var params = []; 
		params = {'id' : param.id};
		var request = {params : params}
		this.imgId.splice(this.imgId.indexOf(param.id),1);
	
		if (!common.isNull(param.id)) {
			await this.$axios.delete(this.$apiHost + '/'+this.$route.name.replace('_detail','') + '/delimage', request)
			.then(res => {
				if (res.data) {
												this.$router.go({name:this.$route.name});
					// this.$buefy.dialog.alert({
					// 	message: 'Complete!',
					// 	size: 'is-medium',
					// 	type: 'is-danger'
					// })
				return false;
				}
			});
		}
	} catch (error) {
		console.log(error)
	}
},
		/*
		* handsontable 문제가 있음 화면에 정상 랜더링이 아니면 화면이 나타나지 않음 그래서 setTimeout으로 2번 실행하여 랜더링 위치 잡는 함수
		*/
		rendertab() {
		// height 는 Hansontable이 height를 설정하지 않으면 Handsontable event 가 일어날때마다 계속 height가 무한정 늘어남
		// hotInstance의 updateSettings를 사용하여 기본 setting 값을 수정 한다.
	let height = (Number(this.height) - 345)+'px';
		
	// handsontable render 기본 높이 구하기
	// let height = (((this.$refs.sheet.hotInstance.countRows()) * 34)+50+100)+'px';
	// this.$refs.sheet.hotInstance.updateSettings({height:height})
	this.$refs.sheet.hotInstance.updateSettings({height:height})

	const rows = (this.$refs.sheet.hotInstance.countRows() / 10) + 1;
	for(let i = 0; i < rows ;i++){
		setTimeout(() => {this.$refs.sheet.hotInstance.render();}, 10 * 20)
		// this.$refs.sheet.hotInstance.render();
	}
				//let height = this.$refs.sheet.hotInstance.countRows() * 34 + 500 + "px";
				//this.$refs.sheet.hotInstance.updateSettings({ height: height });
				// Handsontable 문제로 화면이 전환될때 기존에 출력 화면 위치를 잃어 버림, render를 한번 사용하면 화면에 출력될 디자인만 그린다
				// 출력 위치까지 잡으려면 render를 한번 더 사용해야한다. 연속으로 render를 하면 되지 않아서 setTimeout으로 약간의 시간차를 두고 render 실행한다
				// 하지만 tab를 사용할 때 데이터가 있다면 4줄정도만 나오게 된다. 이부분 때문에 동일한 render를 무려 8번이나 실행했다.
				// 그렇다고 setTimeout의 시간을 늘려 render 시간을 해주는건 헛수고 이다.
				// 짧은 시간 반복 횟수가 중요 함 (10*20 timeout이 가장 적절하며, 20이하는 render 안됨)
				//setTimeout(() => {
				//this.$refs.sheet.hotInstance.render();
				//}, 10 * 80);
			 // this.$refs.sheet.hotInstance.render();
//else {
			//  setTimeout(() => {
				//this.$refs.sheet.hotInstance.render();
				//}, 10 * 20);
				//this.$refs.sheet.hotInstance.render();
		//}
		},
		/*
		* Auto Data
		*/
		async getAutoCompleteData() {
				await this.$axios.get(this.$apiHost + "/users/auto").then(res => {
						for(let i in res.data.userArr){
								res.data.userArr[i]['auto'] = res.data.userArr[i].userId +"/"+res.data.userArr[i].userName;
						}
						this.autoClientData = res.data.userArr//자동완성 데이터
						this.autoCompanyData = res.data.companyArr.map(obj => obj.companyName); //자동완성 데이터
						this.autoClientData = res.data.userArr.map(obj => obj.auto); //자동완성 데이터
				});
		},
		/*
		* page Loading bar
		*/
		async openLoading() {
				this.isLoading = true;
				setTimeout(() => {
						this.isLoading = false;
				}, 10 * 1000);
		},
		sendId(id){
				bus.$emit("receptid", id);
		},
/*
*  excel
*/
excelFileHandler(files) {
	if (files.length > 0) {
		console.log(1)
		let tForm = new FormData();
		for (let i in files) {
			tForm.append('file', files[i])
		}
		let formData = new FormData();
		for (let pair of tForm.entries()) {
			formData.append(pair[0], pair[1]);
		}
	
		this.excelFileFormData = formData;
		this.excelFileHandleFlag = true;
		this.boolChange = true;
	} else {
		this.excelFileHandleFlag = false;
	}
},
// excel
async excelUpload() {
	if (this.excelFileHandleFlag || this.excelId.length > 0) {
		try {
			let formData = new FormData();
			if (this.excelFileHandleFlag) {
				formData = this.excelFileFormData;
			} 
			formData.append('uid', this.properties.uid);
			formData.append('ssid', this.ssid);
			formData.append('copyId', this.excelId);

			await this.$axios.post(`${this.$apiHost}/files/excel`, formData, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
			})
			return false;
		} catch (error) {
			console.log(error)						
			return false;
		}
	}
},
async getExcel(){
	try {
		if(!common.isNull(this.properties.uid)){
			let params = [];
			params = {
				'id' : this.properties.uid
			};
			let request = {params : params};
			const result = await this.$axios.get(`${this.$apiHost}/files/excel`, request);
		
			if (result.data.length > 0) {
				let path = [];
				for (let i of result.data) {
					path.push(i.fileName)
					this.excelId.push(i.id)
				}
				this.downloadList.Excel = path;
				this.downloadList.Excel_info = result.data;
			}
			return false;
		} else {
			return false;
		}

	} catch (error) {
		console.log(error);
	}
},
async excelDialogHandler(){
	this.excelDialog = true;
	return false;
},
/*
* QC Report 
*/
async loadExcel(){
	try {
		if (this.selectExcel) {
			let path = `https://lims.accugenelab.com/excel/samplelist/${this.selectExcel}`;
			window.open(path);

			this.selectExcel = '';
			this.excelDialog = false;

			return false;
		} else {
			this.$buefy.dialog.alert({
				message: 'Please select a report',
				size: 'is-medium',
				type: 'is-danger'
			})
			return false;
		}

	} catch (error) {
		console.log(error);
	}
},
async deleteExcel_DialogHandler(){
	this.deleteExcelDialog = true;
	return false;
},
/*
* QC Report 
*/
async deleteExcel(){
	try {
		if (this.selectExcel) {
			let params = []; 
			let deleteReport = this.downloadList.Excel_info.find(item => item.fileName === this.selectExcel);
			let { id, fileName } = deleteReport;
			params = {
				id, 
				fileName,
			};
			let request = {params : params}
			const deleteData = await this.$axios.delete(`${this.$apiHost}/files/excel`, request);
			// list
			this.downloadList.Excel = this.downloadList.Excel.filter(item => item !== this.selectExcel);
			// copy id 
			this.excelId = this.excelId.filter(item => item !== id);
			this.selectExcel = '';
			this.deleteExcelDialog = false;
			return false;
		} else {
			this.$buefy.dialog.alert({
				message: 'Please select a report',
				size: 'is-medium',
				type: 'is-danger'
			})
			deleteExcelDialog = false;
			return false;
		}

	} catch (error) {
		console.log(error);
	}
},

},
components: {
datePicker,
		HotTable,
		Chat,
imgUpload,
imageViewer,
excelUpload
},
computed: {
		sheetSettings() {
		let settings = this.$store.getters.sheetSettings;
		return settings;
		},
		filteredCompanyDataArray() {
				return this.autoCompanyData.filter(option => {
						return (
						option
								.toString()
								.toLowerCase()
								.indexOf(this.companyName.toLowerCase()) >= 0
						);
				});
		},
		filteredClientDataArray() {
				return this.autoClientData.filter(option => {
						return (
						option
								.toString()
								.toLowerCase()
								.indexOf(this.clientId.toLowerCase()) >= 0
						);
				});
		}
},
watch: {
		// sampleData:function(){
		// }
}
};
</script>
<style src="../../../node_modules/handsontable/dist/handsontable.full.css"></style>



// WEBPACK FOOTER //
// src/views/Reception/DetailForm.vue